export const colors = {
  buttons: {
    primary: '#0AD9D1',
    primaryHover: '#1DB0AA',
    secondary: '#926DFF',
    secondaryHover: '#7856DC',
    dark: '#0AD9D1',
    darkHover: '#1DB0AA',
    light: '#0F0F0FB2',
    text: '#0D0D0D',
    textAccent: '#0AD9D1',
    textSecondary: '#FFFFFF',
  },
  text: {
    dark: '#0AD9D1',
    accent: '#C8EDEC',
    light: '#FFFFFF',
    active: '#926DFF',
    pale: '#677A79',
  },
  background: {
    light: '#151117',
    dark: '#16151A',
    accent:
      'linear-gradient(180deg, rgba(32, 31, 38, 0.7) 0%, rgba(28, 27, 32, 0.7) 100%)',
    medium: '#222125',
    transparent: '#0F0F0FB2',
    tooltip: '#26242A',
  },
  elements: {
    primary: '#201F26',
    secondary: '#343339',
    accent: '#707070',
    dark: '#474747',
    skeletonPrimary: '#2E2C32',
    skeletonSecondary: '#45424A',
  },
  border: {
    primary: '#464448',
    accent: '#0AD9D1',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #0B384D 40.38%, rgba(11, 56, 77, 0) 100%)', // Needs clarification on exact colors
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    processing: '#88D5ED',
    success: '#BFE1A8',
    reject: '#FFA089',
    transfer: '#FFD889',
    mint: '#A8C8FF',
    text: '#3E3E3E',
  },
  hyperdriver: {
    panelBorder: '#21E5DC',
    panelBackground: 'linear-gradient(110deg, #073D40, #052B31 65%, #063A3E)',
    panelShadow: '0 0 0 1px #0AD9D11A, 0 6px 30px #0AD9D112',
    detailsBackground: 'rgba(5, 19, 24, 0.3)',
    divider: '#83BFC28C',
    dividerSoft: '#47737760',
    textMuted: '#9BB9BC',
    warning: '#F1D69C',
    mechanicsBackground: '#FFFFFF04',
    stepIndexBorder: '#0AD9D166',
    purpleBorder: '#B88CFFA3',
    purpleRow:
      'linear-gradient(180deg, #D6B2FF1F, transparent 46%, #A47BDB0A), linear-gradient(105deg, #32233F, #48305F 55%, #342544)',
    purpleRowHover:
      'linear-gradient(180deg, #D6B2FF29, transparent 50%), linear-gradient(105deg, #3B294E, #543770 55%, #3B2A4F)',
    purpleRowShadow: 'inset 0 1px 0 #E1C5FF4D, inset 0 -1px 0 #B289E229',
    purpleRowShadowHover: 'inset 0 1px 0 #EEDCFF70, inset 0 -1px 0 #B289E240',
    purpleText: '#F2EAF9',
    purpleTextSoft: '#CBBDD9',
    purpleFocus: '#C5ABE7',
    pillBorder: '#CFABF28C',
    pillBackground: 'linear-gradient(180deg, #8B59BB, #66418D)',
    pillShadow: 'inset 0 1px 0 #EED5FF4D, 0 0 14px #A368E52B',
    pillText: '#FFF7FF',
    chevronBorder: '#C7A9E14D',
    chevronColor: '#E8D5FA',
    infoIconBorder: '#BF97E8A3',
    infoIconBackground: 'linear-gradient(145deg, #B080E340, #68448D26)',
    infoIconShadow: 'inset 0 1px 0 #E4CAFF33, 0 0 10px #A46BE31A',
    infoIconColor: '#D4BDF0',
    nestedBorder: '#AC83D680',
    nestedBackground: '#24233455',
    nestedRow:
      'linear-gradient(180deg, #C5A2EB12, transparent 55%), linear-gradient(105deg, #30283D99, #3D2E4F99)',
    nestedRowHover:
      'linear-gradient(180deg, #C5A2EB1A, transparent 55%), #49345FBD',
    nestedRowShadow: 'inset 0 1px 0 #DABAF42B',
    nestedRowShadowHover: 'inset 0 1px 0 #E4C5FF47',
    nestedText: '#E5D7F4',
    nestedAction: '#D6BFEE',
  },
};
